import React from 'react';

function LeftSection({imageURL, productName, productDescription,tryDemo, learnMore, googlePlay, appStore}) {
    return ( 
    <div className='container'>
        <div className='row'>
            <div className='col-6 mb-5'>
                <img src={imageURL} />
            </div>
            <div className='col-6 mt-5'>
                    <h1>{productName}</h1>
                    <p>{productDescription}</p>
                    <a href={tryDemo}style={{textDecoration:"none"}} >Try Demo&nbsp;<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href={learnMore} style={{textDecoration:"none"}}>Learn More&nbsp;<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                    <br/>
                    <br/>
                    <a href={googlePlay}>
                        <img src='media/images/googlePlayBadge.svg'/>
                    </a>
                    <a href={appStore}>
                        <img src='media/images/appstoreBadge.svg'/>
                    </a>
            </div>
        </div>
    </div>
 );
}

export default LeftSection;